export interface IReservationExtraInfo {
  age?: string;
  code?: string;
  height?: string;
}

export interface IReservationExtra {
  code: string;
  name: string;
  rate: number;
  amount: number;
  extraInfo: IReservationExtraInfo[];
}

export interface IWheelsStation {
  name: string;
  code: string;
  address: string;
  zip: string;
  city: string;
  phoneNumber: string;
  latitude: number;
  longitude: number;
  countryCode: string;
  country?: string;
  dropOffOnly: boolean;
  businessName?: string;
  businessId?: string;
  businessAddress?: string;
  businessAddress2?: string;
}

export enum EReservationStatus {
  SENDING = 'SENDING',
  RES = 'RES',
  REJ = 'REJ',
  RUN = 'RUN',
  RNT = 'RNT',
  IN = 'IN',
  CNC = 'CNC',
  REQ = 'REQ',
  OK = 'OK',
}

export type TReservationStatus = EReservationStatus | (string & {});

interface IReservation {
  id: string;
  irn: string;
  status: TReservationStatus;
  refNo: string;
  revision: number;
  currency: string;
  created: string;
  updated: string;
  created_long: string;
  departureCode: string;
  departureName: string;
  departureStation: IWheelsStation;
  returnCode: string;
  returnName: string;
  returnStation: IWheelsStation;
  group: string;
  duration: number;
  totalRate: number;
  baseRate: number;
  vehicleRate: number;
  vehicleName: string;
  outOfHours: number;
  oneWayCharge: number;
  delivery: number;
  oneway: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  dateFrom: string;
  dateFrom_long: string;
  timeFrom: string;
  dateTo: string;
  dateTo_long: string;
  timeTo: string;
  daysFromNow?: number;
  adults: number;
  childs: number;
  infants: number;
  notes: string;
  reservationExtras: IReservationExtra[];
  discountCode?: string;
  meetingPoint?: string;
  meetingPointAirport?: string;
  meetingPointFlightNumber?: string;
  meetingPointEta?: string;
  meetingPointTerminal?: string;
  type?: string;
  pickupInfo?: string;
  returnInfo?: string;
  reasonToCancel?: string;
}

export default IReservation;